import { cssProps } from '@oracle/oraclejet-cssprops';
import { classNames } from '../utils/UNSAFE_classNames';
import { useCallback } from 'preact/hooks';
import { usePress } from '../hooks/UNSAFE_usePress';
import { useFormFieldContext } from '../hooks/UNSAFE_useFormFieldContext';

type Props = {
  maxLength: number;
  valueLength?: number;
  onClick?: () => void; // the calling component should focus on the appropriate element when clicked.
};

const rootStyles = {
  base: cssProps`${{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    cursor: 'text',
    fontSize: 'var(--oj-c-PRIVATE-DO-NOT-USE-typography-body-xs-font-size)',
    lineHeight: 'var(--oj-c-PRIVATE-DO-NOT-USE-typography-body-xs-line-height)',
    color: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-text-color-secondary)',
    textDecorationLine: 'none',
    paddingTop: '0',
    paddingInlineEnd: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-text-to-edge-padding)',
    paddingBottom: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-spacing-1x)',
    paddingInlineStart: 'var(--oj-c-PRIVATE-DO-NOT-USE-text-field-text-to-edge-padding)'
  }}`
};
const remainingTextStyles = {
  hide: cssProps`${{
    visibility: 'hidden'
  }}`
};
// the spans surrounding the {valueLength}, / and {maxlength}  need to be display: inline-block
// so that the order is flipped horizontally in RTL.
const spanStyles = cssProps`${{
  display: 'inline-block'
}}`;

const noop = () => {};

export function MaxLengthCounter({ maxLength, valueLength = 0, onClick }: Props) {
  const { isFocused } = useFormFieldContext();
  // We don't want mousedown on this component to do anything, so prevent the default behavior.
  const killEvent = useCallback((event: Event) => {
    event.preventDefault();
  }, []);
  const textClasses = classNames([!isFocused && remainingTextStyles.hide]);
  const { pressProps } = usePress(onClick ?? noop);
  return (
    <div class={rootStyles.base} onMouseDown={killEvent} {...pressProps}>
      <span class={textClasses}>
        <span class={spanStyles}>{valueLength}</span>
        <span class={spanStyles}>/</span>
        <span class={spanStyles}>{maxLength}</span>
      </span>
    </div>
  );
}
